import { Component, OnInit, Inject } from '@angular/core';
import {  MatInputModule, MatFormFieldModule, MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss']
})
export class MessageDialogComponent {
  msg: string;
  title: string;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = data.title;
    this.msg = data.message;
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/message-dialog/message-dialog.component.ts